import { ApiSchoolsService } from 'src/app/service/api-schools.service';
import { Component, OnInit, AfterViewInit, EventEmitter, Output, HostListener, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, ValidationErrors } from '@angular/forms'; // AbstractControl,   ValidatorFn, Validators
import { HttpHeaders } from '@angular/common/http';
import { School } from 'src/app/model/school.model';
// CREATE imports start here
import Swal from 'sweetalert2';
import { UtilityService } from 'src/app/service/utility.service';

@Component({
    selector: 'app-search-by-districts-layer',
    templateUrl: './search-by-districts-layer.component.html',
    styleUrls: ['./search-by-districts-layer.component.scss']
})
export class SearchByDistrictsLayerComponent implements OnInit {
    @Output() onSearchParmEvent: EventEmitter<any> = new EventEmitter();
    @Output() onResetEvent: EventEmitter<any> = new EventEmitter();
    @Output() onCreateEvent: EventEmitter<any> = new EventEmitter();

    @ViewChild('schoolDistrictName') nextField1!: ElementRef;
    @ViewChild('schoolDistrictCode') nextField2!: ElementRef;
    @ViewChild('schoolDistrictNCES') nextField3!: ElementRef;

    searchSchoolDistrictsForm!: UntypedFormGroup;
    public myError: string = '';
    isLoadingResults = true;
    pasteCount: number = 0;
    pastedText: string = '';

    // CREATE PROPS start here
    createBtnText: string = 'Create';
    isUneditable: boolean = true;
    bCancelCreate: boolean = false;
    isCreated: boolean = false;
    bFocusNextField2: boolean = false;

    ngAfterViewInit() {
        if (this.bFocusNextField2) {
            this.nextField2.nativeElement.focus();
        }
    }

    constructor(private service: ApiSchoolsService, private fb: UntypedFormBuilder, private utilityService: UtilityService) {
        this.searchSchoolDistrictsForm = fb.group({
            schoolDistrictName: ['', [Validators.required]],
            schoolDistrictCode: ['', [Validators.required]],
            schoolDistrictNCES: ['', [Validators.required]],
            txtErrorMsg: ['']
        });
    }

    checkDistrictNameValid() {
        if (this.getFormValidationErrors(this.searchSchoolDistrictsForm) !== null) {
            console.log('checkDistrictNameValid returning false');
            return false;
        }

        if (this.searchSchoolDistrictsForm.controls['schoolDistrictCode'].value === undefined) {
            console.log('checkDistrictNameValid returning false2');
            return false;
        }
        return true;
    }

    checkDistrictCodeValid() {
        console.log('calling checkdistrctcodevalid');
        if (this.getFormValidationErrors(this.searchSchoolDistrictsForm) !== null) {
            return false;
        }

        return true;
    }

    checkDistrictNCESValid() {
        if (this.getFormValidationErrors(this.searchSchoolDistrictsForm) !== null) {
            return false;
        }

        return true;
    }

    checkValid() {
        console.log('calling checkvalid');
        return this.checkDistrictNameValid() && this.checkDistrictCodeValid() && this.checkDistrictNCESValid();
    }

    getFormValidationErrors(form: UntypedFormGroup) {
        if (form) {
            type newObj = { [key: string]: any };

            let res: newObj = {};

            Object.keys(form.controls).forEach((key: string) => {
                console.log('now checking this key  ');
                console.log(key);
                let controlErrors: ValidationErrors = <UntypedFormControl>form.get(key)!.errors;
                if (controlErrors != null) {
                    console.log('control errors');
                    console.log(controlErrors);
                    Object.keys(controlErrors).forEach((keyError) => {
                        if (keyError == 'pattern') {
                            console.log('no error');
                        } else {
                            res[key] = keyError;
                            console.log('found errors');
                            console.log(keyError);
                        }
                    });
                }
            });
            console.log('getFormValidation errors returning');
            console.log(Object.keys(res).length);
            console.log(res);
            return Object.keys(res).length === 0 ? null : res;
        } else {
            console.log('getFormValidation errors returning null');
            return null;
        }
    }

    ngOnInit(): void {
        let params = new HttpHeaders();

        const timeSpinnerOut = setTimeout(() => {
            this.isLoadingResults = false;
            //console.log("searchby setting isLoadingResults to false")
        }, 7000);
    }

    setSchoolDistrictCodeFieldValue(fieldNumber: number, event: any) {
        try {
            this.pasteCount++;
            this.pastedText = event.clipboardData?.getData('text') || '';

            if (fieldNumber == 1) {
                let curVal: string = this.searchSchoolDistrictsForm.controls['schoolDistrictCode'].value || '';
                let iCurLen: number = curVal?.length || 0;
                this.searchSchoolDistrictsForm.controls['schoolDistrictCode'].setValue(curVal.concat(this.pastedText.substring(iCurLen, 5 - iCurLen)));
            }
        } catch (Err) {
            console.log('paste event error:' + Err);
        }
    }

    @HostListener('window:keyup', ['$event'])
    cdsKeyDown(event: KeyboardEvent) {
        const keyCode = event.key;
        //(keyCode == "Control") || (keyCode == "V") || (keyCode == "v") || (keyCode == "Tab") || (keyCode == "ArrowRight") || (keyCode == "ArrowLeft") || (keyCode == "Backspace") || (keyCode == "Delete")
        if (keyCode == ' ' || this.utilityService.isValidKeys(event) || (keyCode >= '0' && keyCode <= '9')) {
            if (keyCode == 'Backspace') {
                const myField = event.target as HTMLInputElement;
                if (myField.value.length == 0) {
                    switch (myField.id) {
                        case 'schoolDistrictCode':
                            this.bFocusNextField2 = true;
                            //this.nextField2.nativeElement.focus();
                            break;
                    }
                }
            }
        } else {
            event.preventDefault();
        }
    }

    inputValidator(event: any) {
        console.log('input validator');
        //console.log(event.target.value);
        const pattern = /^[a-zA-Z]*$/;
        //let inputChar = String.fromCharCode(event.charCode)
        console.log(event.target.value);
        if (pattern.test(event.target.value)) {
            var newVal = event.target.value;
            event.target.value = newVal.replace('a', '');
            // invalid character, prevent input
            console.log('new val:');
            console.log(event.target.value);
        }
    }

    onKeyDown(e: any) {
        console.log('keycheck');
        const pattern = /[0-9\+\-\ ]/;
        let inputChar = e.key.toString();
        console.log(inputChar);

        if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
            // invalid character, prevent input
            console.log('invalid char');
            e.preventDefault();
        } else if (
            e.srcElement.maxLength === e.srcElement.value.length &&
            !(
                inputChar == 'Control' ||
                inputChar == 'V' ||
                inputChar == 'v' ||
                inputChar == 'Tab' ||
                inputChar == 'ArrowRight' ||
                inputChar == 'ArrowLeft' ||
                inputChar == 'Backspace' ||
                inputChar == 'Delete'
            )
        ) {
            console.log('checking len');
            e.preventDefault();

            let nextControl: any = e.srcElement.nextElementSibling;
            while (true) {
                if (nextControl) {
                    switch (e.srcElement.id) {
                        case 'schoolDistrictCode':
                            this.nextField2.nativeElement.focus();
                            break;
                        case 'schoolDistrictNCES':
                            this.nextField3.nativeElement.focus();
                            break;
                    }

                    if (nextControl.type == 'tel') {
                        nextControl.focus();
                        return;
                    } else {
                        nextControl = nextControl.nextElementSibling;
                    }
                } else {
                    return;
                }
            }
        }
    }

    fnSearch() {
        var inSchoolDistrictName = this.searchSchoolDistrictsForm.controls['schoolDistrictName'].value;
        var inSchoolDistrictCode = this.searchSchoolDistrictsForm.controls['schoolDistrictCode'].value;
        var inNces = this.searchSchoolDistrictsForm.controls['schoolDistrictNCES'].value;

        if (inSchoolDistrictName) inSchoolDistrictName = inSchoolDistrictName.trim();
        if (inSchoolDistrictCode) inSchoolDistrictCode = inSchoolDistrictCode.trim();
        if (inNces) inNces = inNces.trim();

        // had to add this for this specific variable only!
        if (inNces == '') {
            inNces = null;
        }

        interface myJsonIntfc {
            schoolDistrictName: '';
            schoolDistrictCode?: '';
            chosenCounties: [];
            chosenRegions: [];
            schoolDistrictNCES?: '';
        }

        const myJson: myJsonIntfc = { schoolDistrictName: inSchoolDistrictName, chosenCounties: [], chosenRegions: [] };

        if (inSchoolDistrictCode) {
            myJson.schoolDistrictCode = inSchoolDistrictCode;
        } else {
            delete myJson['schoolDistrictCode'];
        }
        if (inNces) {
            myJson.schoolDistrictNCES = inNces;
        } else {
            delete myJson['schoolDistrictNCES'];
        }
        this.myError = '';
        this.onSearchParmEvent.emit(myJson);
    }

    catchSearchError(err: any) {
        console.log('search by caught error:' + err);
        this.myError = 'No school results. Please check your input. Error during search:' + err;
    }

    fnReset() {
        this.searchSchoolDistrictsForm.controls['schoolDistrictName'].reset();
        this.searchSchoolDistrictsForm.controls['schoolDistrictCode'].reset();
        this.searchSchoolDistrictsForm.controls['schoolDistrictNCES'].reset();
        this.searchSchoolDistrictsForm.controls['txtErrorMsg'].reset();
        var myJson = {};
        this.myError = '';

        this.onResetEvent.emit(myJson);
    }

    // CREATE methods start here
    fnCancelCreate() {
        this.bCancelCreate = !this.bCancelCreate;
        Swal.fire({
            title: 'Are you sure you want to stop editing and discard all changes made?',
            showDenyButton: true,
            showConfirmButton: false,
            showCancelButton: true,
            denyButtonText: `Confirm`
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info');
                this.isUneditable = !this.isUneditable;
                this.createBtnText = 'Create';
                this.fnReset();
            }
        });
    }

    fnCreate() {
        this.myError = '';
        this.isUneditable = !this.isUneditable;
        if (!this.isUneditable) {
            this.createBtnText = 'Creating...';
            this.bCancelCreate = true;
        } else {
            this.bCancelCreate = false;
            this.createBtnText = 'Create';
        }
        this.onCreateEvent.emit();
    }
}
